<template>
  <div class="details-div">
    <h5>Items in the order</h5>
    <ul class="itemsInOrder m-b-30">
      <li v-for="(item, index) in item.ParentOrder.ShopifyOrderItems" :key="item.id">
        {{ index + 1 }}: {{ item.name }}
      </li>
    </ul>
    <div class="tags">
      <h5>
        Order Tags
      </h5>
      <p>{{ item.ParentOrder.tags && item.ParentOrder.tags }}</p>
    </div>
    <h5>Mini Log</h5>
    <b-list-group class="mini-log">
      <b-list-group-item>Added to list by: <strong>{{ item.WhoAdded ? item.WhoAdded.username : '~Nil~'}}</strong> at <strong>{{ item.createdAt ? moment(item.createdAt).format('DD-MM-YYYY, h:mm a') : '--'  }}</strong></b-list-group-item>
      <b-list-group-item>Print File Sent by: <strong>{{ item.PrintFileSentLastSetBy ? item.PrintFileSentLastSetBy.username : '~Nil~'}}</strong> at <strong>{{ item.printFileSentDateTime ? moment(item.printFileSentDateTime).format('DD-MM-YYYY, h:mm a') : '--'  }}</strong></b-list-group-item>
      <b-list-group-item>Print File Checked by: <strong>{{ item.PrintFileCheckedLastSetBy ? item.PrintFileCheckedLastSetBy.username : '~Nil~'}}</strong> at <strong>{{ item.printFileCheckedDateTime ? moment(item.printFileCheckedDateTime).format('DD-MM-YYYY, h:mm a') : '--'  }}</strong></b-list-group-item>
      <b-list-group-item>Print File Printed by: <strong>{{ item.PrintFilePrintedLastSetBy ? item.PrintFilePrintedLastSetBy.username : '~Nil~'}}</strong> at <strong>{{ item.printFilePrintedDateTime ? moment(item.printFilePrintedDateTime).format('DD-MM-YYYY, h:mm a') : '--'  }}</strong></b-list-group-item>
    </b-list-group>

  </div>
</template>

<script>
  export default {
     props: {
       item: {
         type: Object,
         default: () => ({})
       }
     }
  }
</script>

<style lang="scss" scoped>
   $light_text: rgb(134, 134, 134);
  .details-div{
    margin-top:20px;
    padding: 20px;
    background-color: #fff;
  }
  .itemsInOrder{
    color: $light_text
  }
  .mini-log{
    font-size: 13px;
    color: $light_text
  }
  .tags{
    p{
      color: $light_text
    }
  }
</style>